var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_68505",
    "data-name": "Group 68505",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.941,
    height: 31.539,
    viewBox: "0 0 27.941 31.539",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17736",
    "data-name": "Rectangle 17736",
    width: 27.941,
    height: 31.539,
    fill: "#24336d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68505-2",
    "data-name": "Group 68505",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59256",
    "data-name": "Path 59256",
    d: "M22.228,35.475a2.034,2.034,0,0,0-2.406,3.28,9.9,9.9,0,1,1-11.7,0,2.034,2.034,0,0,0-2.407-3.28,13.97,13.97,0,1,0,16.516,0",
    transform: "translate(0 -29.176)",
    fill: "#24336d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59257",
    "data-name": "Path 59257",
    d: "M72.647,14.988a2.094,2.094,0,0,0,2.094-2.094V2.094a2.094,2.094,0,0,0-4.188,0v10.8a2.1,2.1,0,0,0,2.094,2.094",
    transform: "translate(-58.678 0)",
    fill: "#24336d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e7f3d41c2e99c18d84223eadff9e077e.svg";
export { ForwardRef as ReactComponent };